module.exports = "<div class=\"modal-dialog\">\n\n  <div class=\"modal-title\">\n    <h1>Simulation has been saved</h1>\n  </div>\n\n  <div class=\"modal-footer\">\n    <button class=\"btn\" (click)=\"closeDialog()\">Close</button>\n  </div>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// /home/sboda/Documents/eIRP/MEA_source_code/src/app/components/new-simulation/simulation-saved.dialog.html
// module id = ../../../../../src/app/components/new-simulation/simulation-saved.dialog.html
// module chunks = main